"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaribbeanNetherlandsAreaCodes = exports.CanadaAreaCodes = void 0;
var CanadaAreaCodes = ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905'];
exports.CanadaAreaCodes = CanadaAreaCodes;
var CaribbeanNetherlandsAreaCodes = ['7', // Area code of Bonaire island
'3', // Area code of Sint Eustatius island
'4' // Area code of Saba island
];
exports.CaribbeanNetherlandsAreaCodes = CaribbeanNetherlandsAreaCodes;